import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';
import componentUtils from '../utils/index';

const { createUniqueId, isFunction } = common;
const { $id } = dom;
const { Describe } = componentUtils;

const COMPONENT_ID = 'waimai_mdldewo9';
const describeDraw = new Describe('Draw', COMPONENT_ID);

let windowTop = 0;
function stopBodyScroll(isFixed) {
    if (isFixed) {
        windowTop = document.body.scrollTop || document.documentElement.scrollTop;

        document.body.style.position = 'fixed';
        document.body.style.top = -windowTop + 'px';
    } else {
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, windowTop);
    }
}
class Draw {
    constructor(innerComponent, drawOptions = {}) {
        const drawWrapperId = createUniqueId();
        const maskId = createUniqueId();
        const drawId = createUniqueId();
        const { isShowCloseIcon = true } = drawOptions;
        this.options = drawOptions;
        this.data = {
            drawWrapperId,
            innerComponent,
            maskId,
            drawId,
            isShowCloseIcon: isShowCloseIcon ? 'display:block' : 'display:none',
        };

        this.events = {
            onCloseDraw: this.onCloseDraw,
            onOpenDraw: this.onOpenDraw,
        };

        this.describe = describeDraw;
        this.component = createComponent(tpl, { style, data: this.data }, this.events);
    }
    getComponent = () => {
        return this.component;
    };
    onCloseDraw = (cb) => {
        const { drawWrapperId, maskId, drawId } = this.data;
        const { defaultCloseCb } = this.options;
        const wrapperDom = $id(drawWrapperId);
        const maskDom = $id(maskId);
        const drawDom = $id(drawId);
        drawDom.style.display = 'none';
        // 移除进入动画
        wrapperDom.classList.remove(style.drawWrapperOpen);
        // 添加离开动画
        wrapperDom.classList.add(style.drawWrapperLeave);
        // 背景渐出动画
        maskDom.classList.toggle(style.drawMaskShow);
        setTimeout(() => {
            // 动画执行完成后隐藏
            wrapperDom.classList.add(style.drawWrapperHidden);
            // 移出离开动画
            wrapperDom.classList.remove(style.drawWrapperLeave);
            // 移除背景显示
            maskDom.classList.remove(style.drawMaskDisplay);
            stopBodyScroll(false);
            // 执行关闭回调
            const cbToExecute = cb || defaultCloseCb;
            if (isFunction(cbToExecute)) {
                cbToExecute();
            }
        }, 300);
        return false;
    };

    onOpenDraw = (cb) => {
        const { drawWrapperId, maskId, drawId } = this.data;
        const { defaultOpenCb } = this.options;
        const wrapperDom = $id(drawWrapperId);
        const maskDom = $id(maskId);
        const drawDom = $id(drawId);
        drawDom.style.display = 'block';

        // 展示元素
        wrapperDom.classList.remove(style.drawWrapperHidden);
        // 【关闭动画效果】并移出
        wrapperDom.classList.add(style.drawWrapperTransitionRemove);
        // 取消【关闭动画效果】
        window.requestAnimationFrame(() => {
            wrapperDom.classList.remove(style.drawWrapperTransitionRemove);
        });
        // 打开，执行动画
        wrapperDom.classList.add(style.drawWrapperOpen);
        // 背景渐入动画
        maskDom.classList.add(style.drawMaskDisplay);
        maskDom.classList.toggle(style.drawMaskShow);
        stopBodyScroll(true);
        setTimeout(() => {
            const cbToExecute = cb || defaultOpenCb;
            if (isFunction(cbToExecute)) {
                cbToExecute();
            }
        }, 300);
        return false;
    };
}

export default Draw;
